// 月初现金余额管理
export default {
  interestDailyReport: {
    search: {
      interestDateStart: '日期从',
      interestDateEnd: '日期到',
    },
    column: {
      orderCompany: '公司',
      orderDepartmentCode: '部门编码',
      orderDepartment: '部门',
      interestDate: '日期',
      lastCachOccupancyAmount: '上日余额',
      cachReceiptAmount: '本日现金收款',
      cachPaymentAmount: '本日现金付款',
      cachOccupancyAmount: '本日现金占用余额',
      cachOccupancyInterestAmount: '本日现金占用利息',
      receiptBillAmount: '应收票据余额',
      endorseAmount: '背书票据余额',
      receiptBillOccupancyAmount: '应收票据占用额',
      receiptBillInterestAmount: '应收票据利息',
      paymentBillAmount: '自开票据余额',
      paymentBillInterestAmount: '自开票据利息',
      internationalClAmount: '进口信用证余额',
      internationalClInterestAmount: '进口信用证利息',
      domesticClAmount: '国内信用证余额',
      domesticClInterestAmount: '国内信用证利息',
      financingAmount: '贸易融资余额',
      financingInterestAmount: '贸易融资利息',
      interestAmount: '利息总额',
    },
    message: {
      noExport: '当前没有数据可以导出！',
    },
  },
};
